import formatCurrency from '@utils/format/formatCurrency';

export default function formatUSD(value: number, locale = 'en') {
  return formatCurrency(value, 'USD', locale);
}
